import { getDeviceInfo } from "../Upshow";

export const isXumoDevice = () => getDeviceInfo().model.toLowerCase() === 'xumo';